export default {
	title: 'अक्षम तत्व',
	empty: 'इस परिदृश्य में कोई अक्षम तत्व नहीं',
	no_scenario: 'अक्षम तत्व देखने के लिए एक परिदृश्य चुनें'
};
